import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

const kubernetesReactTranslationRef = createTranslationRef({
  id: "kubernetes-react",
  messages: {
    podDrawer: {
      buttons: {
        delete: "Delete Pod"
      }
    }
  }
});

export { kubernetesReactTranslationRef };
//# sourceMappingURL=translation.esm.js.map
